// extracted by mini-css-extract-plugin
module.exports = {"text":"EasterEggTip-module--text--1JnvV"};